export class Vertex {
  x: number;
  y: number;

  constructor(x, y: number) {
    this.x = x;
    this.y = y;
  }
}
